module.exports = __webpack_public_path__ + "img/london.e4dee472.png";